import type { CourseModule } from "@/core/types";
import { lektionAnsichten } from "./lektion-01-ansichten";
import { lektionBerechnung } from "./lektion-02-berechnung";
import { lektionMakros } from "./lektion-03-makros";
import { lektionBarrierefreiheit } from "./lektion-04-barrierefreiheit";

/**
 * Die Registerkarten „Ansicht“, „Formeln → Berechnung“ und „Überprüfen →
 * Barrierefreiheit“ sowie Makros. Die Fensteransicht liefert nur
 * ExcelApiDesktop 1.1; Fensterteilung, Überwachungsfenster, Alternativtexte
 * von Diagrammen und aufgezeichnete Makros kennt nur VBA.
 */
export const modulAnsichtMakros: CourseModule = {
  id: "ansicht-makros",
  title: "Ansichten, Berechnung und Makros",
  summary:
    "Umbruchvorschau und geteilte Fenster, Berechnungsoptionen und Überwachungsfenster, " +
    "aufgezeichnete Makros und barrierefreie Mappen.",
  level: "Aufbau",
  lessons: [lektionAnsichten, lektionBerechnung, lektionMakros, lektionBarrierefreiheit],
};
